import { makeActionCreator } from '../../../../../utilities'
import { GlassgowCommaScoreConstants } from './glassgowCommaScore.constants'

export const setEyeResponse = makeActionCreator(GlassgowCommaScoreConstants.SET_EYE_RESPONSE, 'gcsEye')
export const setEyePNNV = makeActionCreator(GlassgowCommaScoreConstants.SET_EYE_PNNV, 'gcsEyePNNV')
export const setVerbalResponse = makeActionCreator(GlassgowCommaScoreConstants.SET_VERBAL_RESPONSE, 'gcsVerbal')
export const setVerbalPNNV = makeActionCreator(GlassgowCommaScoreConstants.SET_VERBAL_PNNV, 'gcsVerbalPNNV')
export const setMotorResponse = makeActionCreator(GlassgowCommaScoreConstants.SET_MOTOR_RESPONSE, 'gcsMotor')
export const setMotorPNNV = makeActionCreator(GlassgowCommaScoreConstants.SET_MOTOR_PNNV, 'gcsMotorPNNV')
export const setTotalPNNV = makeActionCreator(GlassgowCommaScoreConstants.SET_TOTAL_REASON_PNNV, 'gcsPNNV')
export const setQualifier = makeActionCreator(GlassgowCommaScoreConstants.SET_QUALIFIER, 'qualifier')
export const setQualifierPNNV = makeActionCreator(GlassgowCommaScoreConstants.SET_QUALIFIER_PNNV, 'qualifierPNNV')
export const saveGlassgowCommaScore = makeActionCreator(GlassgowCommaScoreConstants.SAVE_GLASSGOW_COMMA_SCORE)
export const setGlassgowCommaScore = makeActionCreator(GlassgowCommaScoreConstants.SET_GLASSGOW_COMMA_SCORE, 'gcs')
export const setGlassgowCommaScoreData = makeActionCreator(
  GlassgowCommaScoreConstants.SET_GLASSGOW_COMMA_SCORE_DATA,
  'gcsData'
)
export const resetGlassgowCommaScoreData = makeActionCreator(GlassgowCommaScoreConstants.RESET_GLASSGOW_COMMA_SCORE)
export const setEyeReasonEnabled = makeActionCreator(
  GlassgowCommaScoreConstants.SET_EYE_PNNV_ENABLED,
  '_isGcsEyePNNVEnabled'
)
export const setVerbalReasonEnabled = makeActionCreator(
  GlassgowCommaScoreConstants.SET_VERBAL_PNNV_ENABLED,
  '_isGcsVerbalPNNVEnabled'
)
export const setMotorReasonEnabled = makeActionCreator(
  GlassgowCommaScoreConstants.SET_MOTOR_PNNV_ENABLED,
  '_isGcsMotorPNNVEnabled'
)
export const setTotalReasonEnabled = makeActionCreator(
  GlassgowCommaScoreConstants.SET_TOTAL_PNNV_ENABLED,
  '_isGcsPNNVEnabled'
)
